{
  "resourceType": "CodeSystem",
  "status": "draft",
  "content": "complete",
  "name": "SourceKind",
  "id": "source-kind",
  "title": "Panel Health Source Kind",
  "description": "Kinds of source material imported into Panel Health.",
  "version": "0.0.1",
  "url": "https://casetech.app/fhir/CodeSystem/source-kind",
  "concept": [
    {
      "code": "pasted-note",
      "display": "Pasted note"
    },
    {
      "code": "note-template",
      "display": "Note template"
    }
  ],
  "count": 2
}
